import styled, { css } from 'styled-components'
import { disableSomeContentStyles } from 'styles/mixins'

export const DisabledContainer = styled.div<{ $disabled?: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    css`
      & > * {
        ${disableSomeContentStyles()}
      }
    `}
`
